import {http} from './services/manager/HttpManager'
import {authWS} from './services/ws/AuthWS'
import {appWS} from './services/ws/AppWS'
import {beaconWS} from './services/ws/BeaconWS'
import {libraryWS} from './services/ws/LibraryWS'
import {contentWS} from './services/ws/ContentWS'
import {designWS} from './services/ws/DesignWS'
import {userManagementWS} from './services/ws/UserManagementWS'
import {teamWS} from './services/ws/TeamWS'
import {notifWS} from './services/ws/NotifWS'
import {configurationWS} from './services/ws/ConfigurationWS'
import {planWS} from './services/ws/PlanWS'
import {mapWS} from './services/ws/MapWS'
import {localeWS} from './services/ws/LocaleWS'
import {deployWS} from './services/ws/DeployWS'
import {adminWS} from './services/ws/AdminWS'
import {analyticsWS} from './services/ws/AnalyticsWS'
import {apiKeyWS} from './services/ws/ApiKeyWS'
import {datasourcesWS} from './services/ws/DatasourcesWS'
import {chatWS} from './services/ws/ChatWS'
import {formsWS} from './services/ws/FormWS'

export default {
  http,
  authWS,
  appWS,
  beaconWS,
  localeWS,
  configurationWS,
  libraryWS,
  contentWS,
  designWS,
  userManagementWS,
  teamWS,
  notifWS,
  planWS,
  mapWS,
  deployWS,
  adminWS,
  analyticsWS,
  apiKeyWS,
  datasourcesWS,
  chatWS,
  formsWS,
}
